import { render, staticRenderFns } from "./ClinicianLayoutSubHeader.vue?vue&type=template&id=4ed9836c&scoped=true"
import script from "./ClinicianLayoutSubHeader.vue?vue&type=script&lang=js"
export * from "./ClinicianLayoutSubHeader.vue?vue&type=script&lang=js"
import style0 from "./ClinicianLayoutSubHeader.vue?vue&type=style&index=0&id=4ed9836c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ed9836c",
  null
  
)

export default component.exports